import { Box, Card, CardContent, Skeleton } from "@mui/material";

// Add JobCardRecSkeleton component
const JobCardRecSkeleton = () => (
    <Card
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderRadius: "12px",
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
        transition: "all 0.3s ease",
        border: "1px solid #F0F0F0",
        backgroundColor: "#FFFFFF",
      }}
    >
      <CardContent sx={{ p: 2, flex: 1, display: "flex", flexDirection: "column" }}>
        {/* Company Logo and Name */}
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Skeleton variant="circular" width={48} height={48} sx={{ mr: 2 }} />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="60%" height={24} />
            <Skeleton variant="text" width="40%" height={16} sx={{ mt: 0.5 }} />
          </Box>
        </Box>
  
        {/* Job Title */}
        <Skeleton variant="text" width="80%" height={28} sx={{ mb: 1 }} />
  
        {/* Job Details */}
        <Box sx={{ mb: 2 }}>
          <Skeleton variant="text" width="70%" height={20} sx={{ mb: 0.5 }} />
          <Skeleton variant="text" width="50%" height={20} sx={{ mb: 0.5 }} />
          <Skeleton variant="text" width="60%" height={20} />
        </Box>
  
        {/* Tags */}
        <Box sx={{ display: "flex", gap: 1, mb: 2, flexWrap: "wrap" }}>
          <Skeleton variant="rounded" width={80} height={24} />
          <Skeleton variant="rounded" width={100} height={24} />
          <Skeleton variant="rounded" width={70} height={24} />
        </Box>
  
        {/* Deadline and Location */}
        <Box sx={{ mt: "auto", pt: 2, borderTop: "1px solid #eee" }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
            <Skeleton variant="text" width="40%" height={20} />
            <Skeleton variant="text" width="30%" height={20} />
          </Box>
          <Skeleton variant="text" width="50%" height={20} />
        </Box>
      </CardContent>
    </Card>
  ) ;export default JobCardRecSkeleton